/*
 * opening act. — RECENTLY VIEWED
 *
 * - Remembers the products a visitor opens (handles only, newest first) in
 *   THEIR OWN browser (localStorage), and only once they have allowed
 *   "preferences" in the cookie banner (Shopify Customer Privacy API).
 *   Declining clears the list. Nothing is sent to a server or a third party.
 * - Cart drawer: "YOUR CART | RECENTLY VIEWED" tabs (snippets/cart-drawer.liquid).
 * - Cart page: a "Recently viewed" carousel (sections/oa-recently-viewed.liquid).
 *
 * The cards are rendered by Shopify (Section Rendering API on the search
 * route, handles passed as search terms), so they look exactly like every
 * other product card in the shop.
 */
(function () {
  if (window.__oaRv) return;
  window.__oaRv = true;

  /* the furniture product page keeps its own list (layout/moebel.liquid sets 'oa-rv-mb') */
  var KEY = window.__oaRvKey || 'oa-rv';
  var MAX = 20;
  var current = window.__oaRvHandle || null;

  function read() {
    try {
      var a = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(a) ? a.filter(function (h) { return typeof h === 'string' && /^[a-z0-9-]+$/.test(h); }) : [];
    } catch (e) {
      return [];
    }
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); } catch (e) {}
  }
  function clear() {
    try { localStorage.removeItem(KEY); } catch (e) {}
  }

  function withConsent(cb) {
    var S = window.Shopify;
    function ask() {
      try { cb(!!S.customerPrivacy.preferencesProcessingAllowed()); } catch (e) { cb(false); }
    }
    if (S && S.customerPrivacy && S.customerPrivacy.preferencesProcessingAllowed) return ask();
    if (S && S.loadFeatures) {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (err) return cb(false);
        ask();
      });
    } else {
      cb(false);
    }
  }

  function track() {
    if (!current) return;
    var a = read().filter(function (h) { return h !== current; });
    a.unshift(current);
    write(a);
  }

  function list() {
    return read().filter(function (h) { return h !== current; }).slice(0, 16);
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // mode: 'oarv-cart' | 'oarv-drawer'. Calls back with the section element or null.
  function fetchSection(mode, cb) {
    var a = list();
    if (!a.length) return cb(null);
    var url = root() + 'search?type=product&q=' + encodeURIComponent([mode].concat(a).join(' ')) +
      '&section_id=oa-recently-viewed';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return cb(null);
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sec = doc.querySelector('.shopify-section') || doc.body;
        cb(sec && sec.querySelector('[data-oa-rv-count]') ? sec : null);
      })
      .catch(function () { cb(null); });
  }

  /* ---------------- Cart drawer ---------------- */
  var drawerHTML = null;

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  function applyDrawer() {
    var cd = drawerEl();
    if (!cd) return;
    var has = !!drawerHTML;
    cd.classList.toggle('oa-rv-has', has);
    if (!has) cd.classList.remove('oa-rv-on');
    var tab = cd.querySelector('[data-oa-cd-tab="rv"]');
    var sep = cd.querySelector('.oa-cd-tabs__sep--rv');
    var panel = cd.querySelector('[data-oa-cd-rv]');
    if (tab) tab.hidden = !has;
    if (sep) sep.hidden = !has;
    if (panel && has && panel.dataset.oaFilled !== drawerHTML.length + '') {
      panel.innerHTML = drawerHTML;
      panel.dataset.oaFilled = drawerHTML.length + '';
    }
    var on = cd.classList.contains('oa-rv-on');
    // Cart tabs: YOUR CART or the other area (FURNITURE / FASHION, oa-cart-split.js)
    var cartTab = cd.getAttribute('data-oa-view') === 'other' ? 'other' : 'cart';
    cd.querySelectorAll('[data-oa-cd-tab]').forEach(function (t) {
      var k = t.getAttribute('data-oa-cd-tab');
      // WISHLIST tab (assets/oa-wishlist.js) wins while it is on
      var act = cd.classList.contains('oa-wl-on') ? k === 'wl' : on ? k === 'rv' : k === cartTab;
      t.classList.toggle('is-active', act);
      t.setAttribute('aria-selected', act ? 'true' : 'false');
    });
  }

  window.oaRvApplyDrawer = applyDrawer;

  function loadDrawer() {
    if (!drawerEl()) return;
    fetchSection('oarv-drawer', function (sec) {
      drawerHTML = sec ? sec.innerHTML : null;
      applyDrawer();
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-oa-cd-tab]');
    if (!t) return;
    var cd = t.closest('cart-drawer');
    if (!cd) return;
    var k = t.getAttribute('data-oa-cd-tab');
    if (k === 'wl') return; // assets/oa-wishlist.js
    cd.classList.remove('oa-wl-on');
    cd.classList.toggle('oa-rv-on', k === 'rv');
    if (k === 'cart' || k === 'other') {
      cd.setAttribute('data-oa-view', k === 'other' ? 'other' : 'home');
      if (window.oaCartSplit) window.oaCartSplit.apply();
    }
    applyDrawer();
  });
  // ADD TO CART under a recently viewed card: same request the product page
  // makes - like the wishlist: three dots, a tick "Added", then the drawer
  // re-renders itself and switches to YOUR CART.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-oa-rv-add]');
    if (!b) return;
    e.preventDefault();
    var cd = drawerEl();
    if (!cd || b.classList.contains('oa-atc-busy') || b.classList.contains('is-added')) return;
    b.classList.add('oa-atc-busy');
    var fd = new FormData();
    fd.append('id', b.getAttribute('data-oa-rv-add'));
    fd.append('quantity', '1');
    if (typeof cd.getSectionsToRender === 'function') {
      fd.append('sections', cd.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }
    var addUrl = (window.routes && window.routes.cart_add_url) || root() + 'cart/add';
    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd,
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        b.classList.remove('oa-atc-busy');
        if (res.status) {
          b.textContent = res.description || 'Not available';
          b.disabled = true;
          return;
        }
        b.classList.add('is-added');
        setTimeout(function () {
          if (window.publish && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'oa-recently-viewed', cartData: res });
          }
          if (typeof cd.renderContents === 'function') cd.renderContents(res);
        }, 650);
      })
      .catch(function () {
        b.classList.remove('oa-atc-busy');
      });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target.closest && e.target.closest('h2[data-oa-cd-tab]');
    if (!t) return;
    e.preventDefault();
    t.click();
  });

  // The drawer re-renders itself (cart.js / cart-drawer.js replace its HTML):
  // put the tab state back, and after a cart change refresh the list (what is
  // in the cart is left out of it). Adding to cart always shows the cart tab.
  if (window.customElements) {
    customElements.whenDefined('cart-drawer').then(function () {
      var C = customElements.get('cart-drawer');
      if (C && !C.prototype.__oaRv) {
        var orig = C.prototype.renderContents;
        C.prototype.renderContents = function () {
          this.classList.remove('oa-rv-on');
          return orig.apply(this, arguments);
        };
        C.prototype.__oaRv = true;
      }
    });
  }
  var mo;
  function observeDrawer() {
    var cd = drawerEl();
    if (!cd || mo) return;
    var t;
    mo = new MutationObserver(function (muts) {
      // Only react to the drawer re-rendering itself (its HTML is replaced),
      // not to our own panel fill or small updates inside it.
      var rerender = muts.some(function (m) {
        return m.target.id === 'CartDrawer' || (m.target.classList && m.target.classList.contains('drawer__inner'));
      });
      if (!rerender) return;
      clearTimeout(t);
      t = setTimeout(function () {
        applyDrawer();
        if (drawerHTML !== null || list().length) loadDrawer();
      }, 60);
    });
    mo.observe(cd, { childList: true, subtree: true });
  }

  /* ---------------- Cart page ---------------- */
  function loadCartPage() {
    var host = document.querySelector('[data-oa-rv-host]');
    if (!host) return;
    var done = function () {
      /* tells the product-page tabs (snippets/oa-recs-tabs.liquid) the row is final */
      try { host.dispatchEvent(new CustomEvent('oa-rv:done')); } catch (e) {}
    };
    fetchSection(host.getAttribute('data-oa-rv-mode') || 'oarv-cart', function (sec) {
      if (!sec) {
        host.hidden = true;
        host.innerHTML = '';
        done();
        return;
      }
      host.innerHTML = sec.outerHTML;
      host.hidden = false;
      done();
      if (!customElements.get('simple-carousel') && host.dataset.carouselSrc &&
          !document.querySelector('script[src="' + host.dataset.carouselSrc + '"]')) {
        var s = document.createElement('script');
        s.src = host.dataset.carouselSrc;
        document.head.appendChild(s);
      }
    });
  }
  // Scripts inside fetched HTML don't run — the row's prev/next buttons are
  // wired here instead.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-oa-rv-host] .oa-fc-nav__btn');
    if (!b) return;
    var nav = b.closest('.oa-fc-nav');
    var c = nav && document.getElementById(nav.dataset.carousel);
    if (c && typeof c.step === 'function') c.step(parseInt(b.dataset.dir, 10));
  });

  /* ---------------- Start ---------------- */
  function start() {
    withConsent(function (ok) {
      if (!ok) {
        var h = document.querySelector('[data-oa-rv-host]');
        if (h) try { h.dispatchEvent(new CustomEvent('oa-rv:done')); } catch (e) {}
        return;
      }
      track();
      loadDrawer();
      loadCartPage();
    });
    observeDrawer();
  }
  document.addEventListener('visitorConsentCollected', function (e) {
    var d = (e && e.detail) || {};
    if (d.preferencesAllowed) {
      track();
      loadDrawer();
      loadCartPage();
    } else if (d.preferencesAllowed === false) {
      clear();
      drawerHTML = null;
      applyDrawer();
      var host = document.querySelector('[data-oa-rv-host]');
      if (host) { host.hidden = true; host.innerHTML = ''; }
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
